import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const TeamGroupSchema = (localeCodes, isEdit = false) => Yup.object().shape({
  sport_id: Yup
    .string()
    .label("Sport ID")
    .required(),
  parent_id: Yup
    .string()
    .label("Parent Team Group ID")
    .nullable(),
  code: Yup
    .string()
    .label("ID")
    .required()
    .max(50),
  localizations: createLocalizationsSchema(localeCodes),
  icon: Yup.mixed().label("Icon").when([], {
    is: () => isEdit,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.required(),
  }),
  status: Yup
    .string()
    .label("Status")
    .required()
    .oneOf(Object.values(STATUS)),
});

export default TeamGroupSchema;
